import React, { PureComponent } from 'react';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from 'recharts';

export default class LineChartComponent extends PureComponent {
    render() {
        return (
            <ResponsiveContainer width="90%" height="30%">
                <LineChart
                    width={900}
                    height={300}
                    data={this.props.comparativeHoursData}

                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line  strokeWidth={3} type="monotone" dataKey="agreementHour" stroke="#073763" activeDot={{ r: 10 }} />
                    <Line strokeWidth={3} type="monotone" dataKey="hoursDone" stroke="#f0076f" />
                </LineChart>
            </ResponsiveContainer>
        );
    }
}
